<template>
    <dash
        icon="fa fa-refresh"
        titulo="REABERTURAS DE ENTREGAS"
        subTitulo="SGF UABS"
        @click.native="$router.push({ name: 'Uabs_SolicitacoesReaberturas' })"
        :qtd="qtd"
        :mostrarQtd="$temAcessoView('CRED-UABS-ENTR-07') ? true : false"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>
